import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const ReviewRefineContainer = styled('div')({
  backgroundColor: theme.colors.neutral[400],
  width: 'calc(100% - 18px)', // 9px of margin on each side
  marginTop: '.63em',
  padding: '19px 19px 16px 19px',
  [legacyTheme.breakpoints.up('md')]: {
    width: 'calc(140px + 8px + 24px + 30vw)', // To match the ProductCardCheckout width (8px of grid gap + 24px of padding...)
  },
});

const ReviewRefineTitle = styled(Typography)({
  color: theme.colors.primary[400],
  fontWeight: 600,
  lineHeight: '1.62em',
  marginBottom: '.7em',
});

const ReviewRefineText = styled(Typography)({
  color: theme.colors.neutral[800],
  letterSpacing: '0.5px',
});

const ReviewRefineTag = () => (
  <ReviewRefineContainer data-testid="review-refine-section-cart">
    <ReviewRefineTitle align="center" color="noir" variant="mono2">
      Review & Refine
      <span aria-label="Trademark" role="img">
        ®
      </span>
    </ReviewRefineTitle>

    <ReviewRefineText align="center" color="noir" variant="p3">
      Reviewed products will be formulated based on your most recent feedback on each product.
    </ReviewRefineText>
  </ReviewRefineContainer>
);

export default ReviewRefineTag;
